<div>
  <img class="overtop-img" [src]="image?.url" [alt]="image?.alternativeText"/>
</div>